import React from "react";

function ManageBanner() {
  return <div>ManageBanner</div>;
}

export default ManageBanner;
